export default __webpack_public_path__ + "static/media/Assess_Candidates_Upload_Template_ARS.bb06d1dc.xlsx";